/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import AutocompleteComponent from '../../common/component/AutocompleteComponent';
import Container from 'saur_ui_library/src/Atoms/Container/Container';
import Word from 'saur_ui_library/src/Atoms/Word/Word';
import { FilterStyles } from '../../module/table/tableCss';

const SingleFilter = (props: any) => {
  const [module] = useState<string>(props.module);
  const [title] = useState<string>(props.title);
  const [filtreName] = useState<string>(props.filterName);
  const [optionsFilter, setOptionsFiltre] = useState<any>(
    props.filterOptions || []
  );
  const [filterParam, setFilterParam] = useState<any>(null);
  // event to trigger update content of table
  useEffect(() => {
    if (filterParam !== null) return props.parentCallback(filterParam);
  }, [filterParam]);

  // get new values of options
  useEffect(() => {
    setOptionsFiltre(props.filterOptions);
  }, [props.filterOptions]);

  // onChange of dropdownlist
  const onFilterChange = (event: any, option: any) => {
    if (option === null) {
      const objectToSend = { name: '', code: '', paths: '' };
      setFilterParam(objectToSend);
      window.sessionStorage.setItem(
        module + '_' + filtreName,
        JSON.stringify(objectToSend)
      );
    } else {
      const objectToSend = {
        name: option.name,
        code: option.code,
        paths: option.paths || '',
      };
      setFilterParam(objectToSend);
      window.sessionStorage.setItem(
        module + '_' + filtreName,
        JSON.stringify(objectToSend)
      );
    }
  };

  return (
    <Container className='filterForm'>
      <Styles />
      <Container className='FormContentContainer'>
        <Container>
          <Word
            value={title}
            textStyle='normalReg'
            variant='p'
            automatedTestId={'id-' + filtreName}
          />
          <AutocompleteComponent
            id={module + '-filtre-' + filtreName}
            Listoption={optionsFilter}
            onChangeValue={onFilterChange}
            defaultValue={
              props.defaultValue ||
              JSON.parse(
                window.sessionStorage.getItem(module + '_' + filtreName)!
              )
            }
          />
        </Container>
      </Container>
    </Container>
  );
};
const Styles = FilterStyles;
export default SingleFilter;